import styles from "@styles/pages/cdp/targeting-guide.module.scss";
import { Currency } from "shared/utils/Currency";

import classNames from "classnames/bind";
import { If } from "shared/components/control-statements";
const css = classNames.bind(styles);

const getMonth = (key) => {
  const months = [
    { label: "Janeiro", value: 1 },
    { label: "Fevereiro", value: 2 },
    { label: "Março", value: 3 },
    { label: "Abril", value: 4 },
    { label: "Maio", value: 5 },
    { label: "Junho", value: 6 },
    { label: "Julho", value: 7 },
    { label: "Agosto", value: 8 },
    { label: "Setembro", value: 9 },
    { label: "Outubro", value: 10 },
    { label: "Novembro", value: 11 },
    { label: "Dezembro", value: 12 },
  ];

  return months[key].label;
};

const getPeriod = (r) => {
  switch (r) {
    case "day":
      return "dias";
    case "month":
      return "meses";
    case "year":
      return "anos";
    default:
      return "";
  }
};

export default function Filters({
  selected_filters,
  appliedFilters,
  onRemove,
}) {
  const formatValues = (filter) => {
    switch (filter.type) {
      case "o.created_at":
        if (filter.operand === "in_last")
          return `Nos últimos ${filter?.values} ${getPeriod(
            filter.value_type
          )}`;
        if (filter.operand === "bt")
          return `Entre ${filter?.values?.[0]} e ${filter?.values?.[1]}`;
        break;
      case "c.count_orders":
      case "c.age":
        return `${Number(filter?.values?.[0]).toLocaleString(
          "pt-BR"
        )} - ${Number(filter?.values?.[1]).toLocaleString("pt-BR")}`;
      case "o.order_total":
      case "c.total_orders":
      case "c.average_ticket":
        return `${Currency.formatCurrency(
          filter?.values?.[0] || 0
        )} - ${Currency.formatCurrency(filter?.values?.[1] || 0)}`;
      case "c.rfv_frequency":
      case "c.days_without_order":
        return `${Number(filter?.values?.[0]).toLocaleString(
          "pt-BR"
        )} - ${Number(filter?.values?.[1]).toLocaleString("pt-BR")}`;
      case "c.birthdate":
        if (filter.operand === "in_last")
          return `Nos últimos ${Number(filter?.values).toLocaleString(
            "pt-BR"
          )} ${getPeriod(filter.value_type)}`;
        if (filter.operand === "in_next")
          return `Nos próximos ${Number(filter?.values).toLocaleString(
            "pt-BR"
          )} ${getPeriod(filter.value_type)}`;
        if (filter.operand === "month") return `${getMonth(filter?.values)}`;
        if (filter.operand === "bt") return `Entre ${filter?.values?.[0]} e ${filter?.values?.[1]}`;
        break;
      case "c.name":
      case "c.doc":
      case "c.email":
        return `${filter?.values.join(" / ")}`;
      case "c.phone":
        return filter?.values
          .map((phone) => phone.replace(/^\+55\s?/, ""))
          .join(" / ");
      default:
        return "";
    }
  };

  const orderFilters = (array, originalArray) => {
    const isInOriginal = (item) =>
      originalArray.some(
        (originalItem) => JSON.stringify(originalItem) === JSON.stringify(item)
      );

    // Ordenar o array: se estiver no original, vai para o final
    return array.sort((a, b) => {
      const aInOriginal = isInOriginal(a);
      const bInOriginal = isInOriginal(b);

      if (aInOriginal && !bInOriginal) return 1;
      if (!aInOriginal && bInOriginal) return -1;
      return 0;
    });
  };

  const sortedFilters = orderFilters(selected_filters, appliedFilters);

  return (
    <div className={styles.filtersContainer}>
      <div className={styles.filters}>
        {(sortedFilters || []).map((filter, index) => {
          if (!filter || !filter?.active) return null;

          return (
            <div
              className={css({
                filter: true,
                applied: appliedFilters?.includes(filter),
              })}
              key={index}
            >
              <div className="d-flex flex-column">
                <p className={styles.rule}>{filter.name}</p>
                <span className={styles.values}>{formatValues(filter)}</span>
              </div>

              <div className="d-flex align-center">
                <div className={styles.divisor} />
                <div className={styles.remove} onClick={() => onRemove(filter)}>
                  <i className="fas fa-circle-xmark" />
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <If cond={sortedFilters.length === 0}>
        <div className="h-100 d-flex flex-col align-center justify-center">
          <p className={styles.emptyText}>Nenhuma filtro aplicado</p>
        </div>
      </If>
    </div>
  );
}
